// extracted by mini-css-extract-plugin
export default {"carousel":"CarouselPump_carousel__JsdC0"};